import { useState, useEffect, useCallback } from 'react';
import useDevActualStatus from './actual_status';

export default (function (connect) {
  const [data, sendMessage, connectionStatus, activeClose] = useDevActualStatus(connect);
  const [status, setStatus] = useState({});

  useEffect(() => {
    if (data) {
      let newStatus = JSON.parse(JSON.stringify(status));
      //-1从未接入，0离线，1在线，2警报中
      Object.keys(data).forEach(machId => {
        newStatus[machId] = -1;
        if (data[machId]['1'] && data[machId]['1'].time !== 0) {
          if (data[machId]['1'].id === 256) newStatus[machId] = 0;
          else if (data[machId]['1'].id === 257) {
            newStatus[machId] = 1;
            if (data[machId]['3'] && data[machId]['3'].id === 769) {
              newStatus[machId] = 2;
            }
          }
        }
      });
      setStatus(newStatus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const newSendMessage = useCallback(
    ids => {
      if (sendMessage) {
        sendMessage(
          JSON.stringify({
            ids,
            groups: [1, 3],
          })
        );
      }
    },
    [sendMessage]
  );

  return [status, sendMessage ? newSendMessage : null, connectionStatus, activeClose];
});
